(function () {
  const root = document.querySelector('[data-karst-country-popup]');
  const configScript = document.querySelector('[data-karst-country-popup-config]');

  if (!root || !configScript) return;

  const STORAGE_KEY = 'karst:localization-country';

  let config = {};
  try {
    config = JSON.parse(configScript.textContent || '{}');
  } catch (error) {
    return;
  }

  function readStoredCountry() {
    try {
      return window.localStorage && window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function storeCountry(countryCode) {
    try {
      if (window.localStorage && countryCode) {
        window.localStorage.setItem(STORAGE_KEY, String(countryCode));
      }
    } catch (error) {}
  }

  if (readStoredCountry()) return;

  function findCountryForm(countryCode) {
    const options = root.querySelectorAll('[data-karst-country-popup-option]');
    for (let i = 0; i < options.length; i++) {
      const form = options[i].closest('form');
      const input = form && form.querySelector('input[name="country_code"]');
      if (input && input.value === countryCode) return form;
    }
    return null;
  }

  function applyQueryParamCountry() {
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return false;
    }

    const rawCountry = params.get('country');
    if (!rawCountry) return false;

    const paramCountry = rawCountry.toUpperCase();
    const availableCountries = config.availableCountries || [];
    if (availableCountries.indexOf(paramCountry) === -1) return false;

    if (paramCountry === config.currentCountry) {
      storeCountry(paramCountry);
      return true;
    }

    const form = findCountryForm(paramCountry);
    if (!form) return false;

    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      storeCountry(paramCountry);
      form.submit();
    }
    return true;
  }

  if (applyQueryParamCountry()) return;

  const backdrop = root.querySelector('[data-karst-country-popup-backdrop]');
  const closeButton = root.querySelector('[data-karst-country-popup-close]');
  const continueButton = root.querySelector('[data-karst-country-popup-continue]');
  const switchButton = root.querySelector('[data-karst-country-popup-switch]');
  const suggestionPhase = root.querySelector('[data-karst-country-popup-phase="suggestion"]');
  const listPhase = root.querySelector('[data-karst-country-popup-phase="list"]');
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('karst-country-popup-no-scroll');
  }

  function unlockScroll() {
    document.body.classList.remove('karst-country-popup-no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function openPopup() {
    root.hidden = false;
    lockScroll();
  }

  function closePopup() {
    root.hidden = true;
    unlockScroll();
    storeCountry(config.currentCountry);
  }

  function showList() {
    if (suggestionPhase) suggestionPhase.hidden = true;
    if (listPhase) listPhase.hidden = false;
  }

  if (closeButton) closeButton.addEventListener('click', closePopup);
  if (backdrop) backdrop.addEventListener('click', closePopup);
  if (continueButton) continueButton.addEventListener('click', closePopup);
  if (switchButton) switchButton.addEventListener('click', showList);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closePopup();
  });

  openPopup();
})();
